// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Jigi","left":"styles_left__1Ljjv"};